(function ($) {
    /**
     * Calculate the max-length from the number of rows and their sizes for a table to collapse
     * @param {jQuery} element
     * @param {number} maxRows
     * @returns {number} the max length to set
     */
    function calculateMaxLength(element, maxRows) {
        return element
            .find('tr')
            .map((_, tr) => $(tr).height())
            .toArray()
            .slice(0, maxRows + 1)
            .reduce((t, u) => t + u, 100 /* In case of scrollbar add some */);
    }

    $(() => {
        $('.table-collapsible__container').each(function () {
            const table = $(this).find('.table-collapsible');

            const maxRows = Number.parseInt(table.data('max-rows'), 10);
            table.css('max-height', `${calculateMaxLength(table, maxRows)}px`);
            table.attr('aria-expanded', 'false');

            const allRows = Number.parseInt(table.data('all-rows'), 10);
            const MAX_HEIGHT_0 = calculateMaxLength(table, allRows);
            const MAX_HEIGHT = Math.trunc(MAX_HEIGHT_0);

            $(this)
                .find('.table-collapsible__button')
                .click(function () {
                    if (Number.parseInt(table.css('max-height'), 10) < MAX_HEIGHT) {
                        $(this).text(localize.translations.less_details_text);
                        table.css('max-height', `${MAX_HEIGHT}px`);
                        table.attr('aria-expanded', 'true');
                    } else {
                        $(this).text(localize.translations.more_details_text);
                        table.css('max-height', `${calculateMaxLength(table, maxRows)}px`);
                        table.attr('aria-expanded', 'false');
                    }
                });
        });
    });
})(jQuery);
